import React, { useState } from 'react';

function DriveInfoAddPanel({ onAdd, onCancel, error }) {
  const [name, setName] = useState('');
  const [param2, setParam2] = useState('');
  const [value, setValue] = useState('');
  const [param1, setParam1] = useState('');
  const [localError, setLocalError] = useState(null);

  const handleOk = () => {
    const trimmedName = (name || '').trim();
    const trimmedParam2 = (param2 || '').trim();
    const trimmedValue = (value || '').trim();
    const trimmedParam1 = (param1 || '').trim();

    if (!trimmedName) { 
      setLocalError('Nazwa nie może być pusta');
      return;
    }
    if (!trimmedValue) {
      setLocalError('Wartość nie może być pusta');
      return;
    }

    setLocalError(null);
    onAdd({ name: trimmedName, param2: trimmedParam2, value: trimmedValue, param1: trimmedParam1 });
  };

  return (
    <div style={{
      background: '#fff',
      borderRadius: 16,
      padding: 32,
      minWidth: 320,
      boxShadow: '0 2px 16px rgba(0,0,0,0.15)',
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
      zIndex: 11000,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      <h3 style={{ marginBottom: 24 }}>Nowy Drive Info</h3>
      <input
        type="text"
        value={name}
        onChange={e => setName(e.target.value)}
        placeholder="Nazwa"
        style={{
          fontSize: '1.1rem',
          padding: '10px',
          borderRadius: 8,
          border: '1px solid #bbb',
          width: 240,
          marginBottom: 16
        }}
        autoFocus
      />
      <input
        type="text"
        value={param2}
        onChange={e => setParam2(e.target.value)}
        placeholder="Flaga"
        style={{
          fontSize: '1.1rem',
          padding: '10px',
          borderRadius: 8,
          border: '1px solid #bbb',
          width: 240,
          marginBottom: 16
        }}
      />
      <input
        type="text"
        value={value}
        onChange={e => setValue(e.target.value)}
        placeholder="Wartość"
        style={{
          fontSize: '1.1rem',
          padding: '10px',
          borderRadius: 8,
          border: '1px solid #bbb',
          width: 240,
          marginBottom: 16
        }}
      />
      <input
        type="text"
        value={param1}
        onChange={e => setParam1(e.target.value)}
        placeholder="Cel"
        style={{
          fontSize: '1.1rem',
          padding: '10px',
          borderRadius: 8,
          border: '1px solid #bbb',
          width: 240,
          marginBottom: 16
        }}
      />
      {(localError || error) && (
        <div style={{ color: 'red', marginBottom: 12 }}>{localError || error}</div>
      )}
      <div style={{ display: 'flex', gap: 16 }}>
        <button
          onClick={handleOk}
          style={{
            padding: '10px 24px',
            fontSize: '1.1rem',
            fontWeight: 600,
            borderRadius: 8,
            border: '1px solid #6cf',
            background: '#eaf6ff',
            color: '#227',
            cursor: 'pointer',
            transition: 'background 0.2s'
          }}
        >OK</button>
        <button
          onClick={onCancel}
          style={{
            padding: '10px 24px',
            fontSize: '1.1rem',
            fontWeight: 600,
            borderRadius: 8,
            border: '1px solid #f66',
            background: '#fff0f0',
            color: '#a22',
            cursor: 'pointer',
            transition: 'background 0.2s'
          }}
        >Anuluj</button>
      </div>
    </div>
  );
}

export default DriveInfoAddPanel;
